import React from 'react';
import { useFormikContext } from 'formik';
import styled, { css } from 'styled-components';

const Container = styled.div`
  margin: 20px 0;
`;

const RadioLabel = styled.div`
  font-size: 20px;
  line-height: 1.5;
  color: 'var(--Text700)';
`;
const OptionsContainer = styled.div`
  display: flex;
  gap: 10px;
  height: 50px;
  ${({ direction }) =>
    direction === 'column' &&
    css`
      flex-direction: column;
      height: auto;
    `}
  justify-content: space-between;
`;
const RadioOption = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 13px 8px;
  border-radius: 4px;
  border: ${({ invalid }) =>
    invalid ? '  solid 1px red' : 'solid 1px #4FB8FF'};
  background-color: ${({ active }) => (active ? '#4FB8FF' : 'var(--Grey300)')};
  @media (max-width: 600px) {
    padding: 13px 10px;
  }
  :hover {
    cursor: pointer;
  }
`;
const RadioNameSpan = styled.span`
  text-align: center;
  inline-size: max-content;
  font-size: 16px;
  font-weight: 900;
  line-height: 1.4;
  color: ${({ active, invalid }) =>
    invalid ? 'red' : active ? '#FFFFFF' : '#4FB8FF'};

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;
const LabelErrorSpan = styled.span`
  font-size: 14px;
  color: red;
`;

const RadioSelect = ({
  label,
  error,
  options,
  value,
  onChange,
  allowMultiple,
  direction,
  fieldName,
}) => {
  const { setFieldValue } = useFormikContext();
  const handleChange = (val) => {
    if (!allowMultiple) {
      onChange(val);
      setFieldValue(fieldName, val);
      return;
    }

    let currValues = value.split(',').filter(Boolean);
    if (currValues?.includes(val)) {
      currValues = currValues.filter((v) => v !== val);
    } else {
      currValues.push(val);
    }
    const newValue = currValues.join(',');
    onChange(newValue);
    setFieldValue(fieldName, newValue);
  };
  return (
    <Container>
      {label && <RadioLabel invalid={error}>{label} </RadioLabel>}
      <OptionsContainer direction={direction}>
        {options.map((option) => {
          const optionSelected = value === option.name;
          return (
            <RadioOption
              key={option.label}
              onClick={() => handleChange(option.name)}
              active={optionSelected}
              invalid={error}
            >
              <RadioNameSpan invalid={error} active={optionSelected}>
                {' '}
                {option.label}
              </RadioNameSpan>
            </RadioOption>
          );
        })}
      </OptionsContainer>
      {error && <LabelErrorSpan> Required</LabelErrorSpan>}
    </Container>
  );
};
export default RadioSelect;
